
import Vue from 'vue';
import { mapGetters } from 'vuex';

export class MenuItem {
  // eslint-disable-next-line no-useless-constructor
  constructor (public libelle: string, public route: string, public icon: string, public bottomMenu: boolean = false, public badge: boolean | number = false, public role?: string) {

  }
}

export default Vue.extend({
  name: 'Menu',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array as () => MenuItem[],
      required: true
    },
    afficherLienAgrial: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showMenu: false,
    mini: true,
    loading: false
  }),
  computed: {
    ...mapGetters({ _tiers: 'tiers/infosTiers', user: 'user/user' }),
    tiers (): any {
      return this._tiers || {};
    },
    currentRoute: {
      get () {
        return this.$route.name;
      }
    },
    itemsBottom () {
      return this.items.filter(i => !!i.bottomMenu);
    }
  },
  watch: {
    show (v) {
      this.showMenu = v;
    },
    showMenu (v) {
      this.$emit('update:show', v);
    }
  },
  methods: {
    navigateTo (pageName: string) {
      this.$router.push({ name: pageName });
    },
    goMonAgrial () {
      const url = window.PROPERTIES.get('agrial.portail.url');
      if (url) {
        window.location.href = url as any;
      }
    }
  }
});
